import { render, staticRenderFns } from "./AboutMobile.vue?vue&type=template&id=7f84d120&scoped=true&"
import script from "./AboutMobile.vue?vue&type=script&lang=ts&"
export * from "./AboutMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f84d120",
  null
  
)

export default component.exports